export const customImageCrops = {
    jumbotronLargeCrops: {
        small: {
            width: 480,
            height: 480
        },
        medium: {
            width: 720,
            height: 720
        },
        large: {
            width: 940,
            height: 940
        }
    }
};
